import {IconProps} from './types';

function AiAgentAttachmentIcon({stroke = 'black', width = 16, height = 16, className}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            className={className}
            aria-hidden
        >
            <path
                d="M5.07867 10.23L10.856 4.45267C10.9813 4.32227 11.1313 4.21818 11.2973 4.14648C11.4632 4.07478 11.6419 4.03692 11.8227 4.0351C12.0035 4.03328 12.1828 4.06756 12.3502 4.13591C12.5176 4.20426 12.6696 4.30532 12.7975 4.43317C12.9253 4.56102 13.0264 4.71309 13.0948 4.88048C13.1631 5.04787 13.1974 5.22722 13.1956 5.40801C13.1938 5.58881 13.1559 5.76743 13.0842 5.93341C13.0125 6.0994 12.9084 6.24941 12.778 6.37467L4.974 14.2033C4.46408 14.7132 3.77251 14.9996 3.05143 14.9995C2.33035 14.9994 1.63883 14.7129 1.129 14.203C0.619166 13.6931 0.332779 13.0015 0.332841 12.2804C0.332904 11.5594 0.61941 10.8678 1.12933 10.358L9.28533 2.20333C9.98621 1.50237 10.9368 1.10853 11.9281 1.10847C12.9194 1.10841 13.87 1.50212 14.571 2.203C15.272 2.90388 15.6658 3.85451 15.6659 4.84576C15.6659 5.83702 15.2722 6.7877 14.5713 7.48867L8.79467 13.2667"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default AiAgentAttachmentIcon;
